export default __webpack_public_path__ + "static/media/expImgWhite.b9923db4.svg";